import { render, staticRenderFns } from "./livestockSummaryFormat1.vue?vue&type=template&id=c959986e&scoped=true&"
import script from "./livestockSummaryFormat1.vue?vue&type=script&lang=js&"
export * from "./livestockSummaryFormat1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c959986e",
  null
  
)

export default component.exports